import React from 'react'
import { Link} from 'gatsby'
import { DateDisplay } from '@utils/DateDisplay'
import SubjectBadge from '../SubjectBadge'
import Thumbnail from '@components/Thumbnail'


const FeaturedItem = ({featuredItem, windowSize}) => {
    
    featuredItem.url = '/items/' + featuredItem.uid;
    console.log(featuredItem)
    if(!featuredItem) return null;
    if(featuredItem.data.thumbnail.url != null){
        return (
            <div className="py-4 media">
                <Link to={ featuredItem.url} aria-label={"link to " + featuredItem.data.title}>
                    <Thumbnail thumbnail={featuredItem.data.thumbnail} useSmall={windowSize.width < 768} isDecorative={false}/>
                </Link>
                <div className="media-body">
                    <h2><Link className="animated" to={ featuredItem.url}>{featuredItem.data.title}</Link></h2>
                    <div className="d-md-flex justify-content-md-start">
                    <span className="font-italic mr-4">{DateDisplay(featuredItem.data.date_published)}</span>
                    <span>
                    {
                        featuredItem.data.body[0].items.map((item, index) => (
                         <SubjectBadge subject={item} key={item.subject.document.id + '-' + featuredItem.id + '-' + index}/>
                        ))
                    }
                    </span>
                </div>
                <p>{featuredItem.data.featured_blurb}</p>
                </div>
            </div>
        )
    }
    else {
        return (
            <div className="py-4">
                <h2>
                    <Link 
                    to={featuredItem.url}
                    key={featuredItem.data.uid} 
                    className="animated" >
                        {featuredItem.data.title}
                    </Link>
                </h2>
                <div className="d-md-flex justify-content-md-start">
                    <span className="font-italic mr-4">{DateDisplay(featuredItem.data.date_published)}</span>
                    <span>
                    {
                        featuredItem.data.body[0].items.map((item) => {
                        return <SubjectBadge subject={item} key={item.uid}/>
                    })
                    }
                    </span>
                </div>
                <p>{featuredItem.data.featured_blurb}</p>
            </div>  

    )
    }
}

export default FeaturedItem;